// extracted by mini-css-extract-plugin
module.exports = {"radioButton":"LearningTime_radioButton__mHlh7","radio":"LearningTime_radio__3X19Y"};